import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/merchants'

const MerchantApiV2 = {
  /**
   * Create merchant endpoint.
   * Invoke `POST api/v2/admins/merchants`
   * @param {object} merchant_values
   */
  create: async (merchant_values) => {
    const path     = API_PATH
    const body     = {
      merchant: merchant_values
    }
    const response = axios.post(path, body)
    return response
  },
  /**
   * Get list of `Merchant`
   * @param {object} params uri parameter
   * @return {object} Collection of `Merchant`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },
  /**
   * Get one `Merchant`
   * @param {object} id merchant id
   * @return {object} `Merchant`
   */
  getSingle: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },
  /**
   * Get one `Merchant`
   * @param {object} id merchant id
   * @return {object} `Merchant`
   */
  update: async (id, merchant_values) => {
    const path     = `${API_PATH}/${id}`
    const body     = {
      merchant: merchant_values
    }
    const response = axios.patch(path, body)
    return response
  },
  /**
   * Get list of Merchants as CSV
   * Invoke `GET api/v2/admins/merchants/csv
   */
  getCsv: async () => {
    const path = `${API_PATH}/csv`

    const response = await axios.post(path, {})
    return response
  }
}

export default MerchantApiV2
